"use strict";
var _default = require("./default.vert.js"), defaultFilter = require("./defaultFilter.vert.js");
const defaultVertex = _default.default, defaultFilterVertex = defaultFilter.default;
exports.defaultFilterVertex = defaultFilterVertex;
exports.defaultVertex = defaultVertex;
//# sourceMappingURL=index.js.map
